import React, { Component } from 'react';
import { MemberReg } from './MemberReg'
import { BusinessInfo } from './BusinessInfo'
import { Termsofservice } from './Termsofservice'
import { Privacypolicy } from './Privacypolicy'
import { HeaderSub } from '../../Common/HeaderSub'

/* 개발담당:양유빈
 * 화면기능:회원가입 컨테이너 페이지
 * 세부설명:회원가입 양식과 사업자 등록증 업로드 양식을 포함하고 있음.
*/
export class Index extends Component {
    static displayName = Index.name;

    constructor(props) {
        super(props);
        this.state = {
            RenderName: this.CompName.MemberReg,  //기본 컴포넌트 할당
            ContentState: null
        };
    }
    //호출할 컴포넌트 이름
    CompName = {
        "MemberReg": "MemberReg",
        "BusinessInfo": "BusinessInfo",
        "Termsofservice": "Termsofservice",
        "Privacypolicy":"Privacypolicy"
    }
    //초기화
    componentDidMount() {
    } 
     
    //컴포넌트간 랜더링
    //RenderComponent 함수를 이용하여 자식 페이지간 이동
    renderPick() {
        
        if (this.state.RenderName === this.CompName.BusinessInfo) {

            return (
                <div>
                    <HeaderSub
                        HeaderTitle="사업자등록증 첨부"
                        ComponentUrl="MemberReg"
                        RenderComponent={(RenderName, ContentState) => this.setState({ RenderName: RenderName, ContentState: ContentState })}
                        ContentState={this.state.ContentState}
                        ComponentName={this.state.RenderName}
                    />
                    <BusinessInfo
                        RenderComponent={(RenderName) => this.setState({ RenderName: RenderName })}
                    />
                </div>
            );
        }
        else if (this.state.RenderName === this.CompName.MemberReg) {
            return (
                <div>
                    <HeaderSub
                        HeaderTitle="회원가입"
                        LinkUrl="/Account/LoginMgr/Index"
                        ComponentName={this.state.RenderName}
                    />
                    <MemberReg
                        RenderComponent={(RenderName, ContentState) => this.setState({ RenderName: RenderName, ContentState: ContentState })}
                        ContentState={this.state.ContentState}
                    />
                </div>

            );
        }
        else if (this.state.RenderName === this.CompName.Termsofservice) {
            return (
                <div>
                    <HeaderSub
                        HeaderTitle="서비스이용약관"
                        ComponentUrl="MemberReg"
                        RenderComponent={(RenderName, ContentState) => this.setState({ RenderName: RenderName, ContentState: ContentState })}
                        ContentState={this.state.ContentState}
                        ComponentName={this.state.RenderName}
                    />
                    <Termsofservice
                        RenderComponent={(RenderName, ContentState) => this.setState({ RenderName: RenderName, ContentState: ContentState })}
                        ContentState={this.state.ContentState}
                    />
                </div>

            );
        }
        else if (this.state.RenderName === this.CompName.Privacypolicy) {
            return (
                <div>
                    <HeaderSub
                        HeaderTitle="개인정보 취급방법"
                        ComponentUrl="MemberReg"
                        RenderComponent={(RenderName, ContentState) => this.setState({ RenderName: RenderName, ContentState: ContentState })}
                        ContentState={this.state.ContentState}
                        ComponentName={this.state.RenderName}
                    />
                    <Privacypolicy
                        RenderComponent={(RenderName, ContentState) => this.setState({ RenderName: RenderName, ContentState: ContentState })}
                        ContentState={this.state.ContentState}
                    />
                </div>

            );
        }
        else {
            return (
                ""
            );
        }
    }
    render() {
        let RnderAct = this.renderPick();
        return (
            <div>
                {RnderAct }
            </div>
        );
    }
}
